import React from 'react';
import { Global, css, Theme } from '@emotion/react';

// Fonts
import 'theme/fonts/muni/stylesheet.css';
import 'theme/fonts/plzen/stylesheet.css';
import 'theme/fonts/liberec/stylesheet.css';
import 'theme/fonts/zlin/stylesheet.css';

// https://make.wordpress.org/accessibility/handbook/markup/the-css-class-screen-reader-text/#the-css
export const OffscreenCSS = css`
	border: 0;
	clip: rect(1px, 1px, 1px, 1px);
	clip-path: inset(50%);
	height: 1px;
	margin: -1px;
	overflow: hidden;
	padding: 0;
	position: absolute;
	width: 1px;
	word-wrap: normal !important;

	&:focus {
		background-color: #eee;
		clip: auto !important;
		clip-path: none;
		color: #444;
		display: block;
		font-size: 1em;
		height: auto;
		left: 5px;
		line-height: normal;
		padding: 15px 23px 14px;
		text-decoration: none;
		top: 5px;
		width: auto;
		z-index: 100000;
	}
`;

export const OverlayCss = css`
	position: absolute;
	top: 0;
	bottom: 0;
	left: 0;
	right: 0;
	color: white;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	background-color: rgba(0, 0, 0, 0.3);
	cursor: pointer;
`;

export const FocusStyle = (theme: Theme) => css`
	transition: box-shadow 0.2s ease-in-out;
	box-shadow: 0 0 1px 1px ${theme.colors.primary};
	outline: none;
`;

export const InvertFocusStyle = css`
	box-shadow: 0 0 1px 1px white;
	outline: none;
`;

const GlobalStyles = () => (
	<Global
		styles={(theme: Theme) => css`
			body {
				margin: 0;
				font-family: ${theme.fontFamily}, -apple-system, BlinkMacSystemFont,
					'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
					'Helvetica Neue', sans-serif;
				-webkit-font-smoothing: antialiased;
				-moz-osx-font-smoothing: grayscale;
				color: ${theme.colors.text};
				background-color: white;
			}

			* {
				font-family: ${theme.fontFamily}, -apple-system, BlinkMacSystemFont,
					'Segoe UI', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans',
					'Helvetica Neue', sans-serif;
			}

			*:focus {
				${FocusStyle(theme)}
			}

			p {
				padding: 0;
				margin: ${theme.space[2]}px 0;
			}

			[data-reach-dialog-overlay] {
				z-index: 999;
			}

			[data-reach-dialog-content] {
				background-color: unset;

				:focus {
					box-shadow: none;
				}
			}

			input {
				min-width: 0;
			}
		`}
	/>
);

export default GlobalStyles;
